module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$route.path.indexOf('_editor') === -1 && _vm.$route.path.indexOf('_detail') === -1) ? _c('div', [_c('div', {
    staticClass: "content-bottom-padded"
  }, [_c('el-alert', {
    attrs: {
      "type": "info",
      "title": "操作说明",
      "show-icon": ""
    }
  }, [_c('div', [_vm._v(" 说明：兑吧订单信息。 ")])])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "用户id"
    },
    model: {
      value: (_vm.params.user_id),
      callback: function($$v) {
        _vm.$set(_vm.params, "user_id", $$v)
      },
      expression: "params.user_id"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.numberSearch
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "兑吧订单号"
    },
    model: {
      value: (_vm.params.orderNum),
      callback: function($$v) {
        _vm.$set(_vm.params, "orderNum", $$v)
      },
      expression: "params.orderNum"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.numberSearch
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "兑吧状态"
    },
    on: {
      "change": _vm.numberSearch
    },
    model: {
      value: (_vm.params.status),
      callback: function($$v) {
        _vm.$set(_vm.params, "status", $$v)
      },
      expression: "params.status"
    }
  }, _vm._l((_vm.dubaStatus), function(selectStatus) {
    return _c('el-option', {
      key: selectStatus.key,
      attrs: {
        "label": selectStatus.name,
        "value": selectStatus.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 10,
      "lg": 8
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "daterange",
      "start-placeholder": "开始日期",
      "ange-separator": "至",
      "end-placeholder": "结束日期",
      "value-format": "yyyy/MM/dd",
      "placeholder": "选择日期范围",
      "size": "mini"
    },
    on: {
      "change": _vm.dateChange
    },
    model: {
      value: (_vm.created),
      callback: function($$v) {
        _vm.created = $$v
      },
      expression: "created"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button-group')], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.list,
      "height": _vm.wheight - 140
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center",
      "label": "全选"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user_id",
      "label": "用户id"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "card_id",
      "label": "np会员卡id"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "expend",
      "label": "积分"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.expend == 1) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v("+ " + _vm._s(scope.row.points))]) : _vm._e(), _vm._v(" "), (scope.row.expend == 0) ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v("- " + _vm._s(scope.row.points))]) : _vm._e()]
      }
    }], null, false, 80484975)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orderNum",
      "label": "兑吧订单号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "bizId",
      "label": "系统单号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": "类型类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.type === 'alipay') ? _c('span', {
          staticClass: "amount-cur"
        }, [_vm._v(" 支付宝 ")]) : _vm._e(), _vm._v(" "), (scope.row.type === 'qb') ? _c('span', {
          staticClass: "amount-cur"
        }, [_vm._v(" Q币 ")]) : _vm._e(), _vm._v(" "), (scope.row.type === 'coupon') ? _c('span', {
          staticClass: "amount-cur"
        }, [_vm._v(" 优惠券 ")]) : _vm._e(), _vm._v(" "), (scope.row.type === 'object') ? _c('span', {
          staticClass: "amount-cur"
        }, [_vm._v(" 实物 ")]) : _vm._e(), _vm._v(" "), (scope.row.type === 'phonebill') ? _c('span', {
          staticClass: "amount-cur"
        }, [_vm._v(" 话费 ")]) : _vm._e(), _vm._v(" "), (scope.row.type === 'phoneflow') ? _c('span', {
          staticClass: "amount-cur"
        }, [_vm._v(" 流量 ")]) : _vm._e(), _vm._v(" "), (scope.row.type === 'virtual') ? _c('span', {
          staticClass: "amount-cur"
        }, [_vm._v(" 虚拟商品 ")]) : _vm._e(), _vm._v(" "), (scope.row.type === 'game') ? _c('span', {
          staticClass: "amount-cur"
        }, [_vm._v(" 游戏 ")]) : _vm._e(), _vm._v(" "), (scope.row.type === 'hdtool') ? _c('span', {
          staticClass: "amount-cur"
        }, [_vm._v(" 活动抽奖 ")]) : _vm._e(), _vm._v(" "), (scope.row.type === 'sign') ? _c('span', {
          staticClass: "amount-cur"
        }, [_vm._v(" 签到 ")]) : _vm._e()]
      }
    }], null, false, 444588615)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "actualPrice",
      "label": "扣费"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.actualPrice / 100) + "\n                ")]
      }
    }], null, false, 1757045568)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "兑吧状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 0) ? _c('span', {
          staticClass: "amount-cur"
        }, [_vm._v(" 未通知 ")]) : _vm._e(), _vm._v(" "), (scope.row.status == 1) ? _c('span', {
          staticClass: "amount-cur"
        }, [_vm._v(" 成功 ")]) : _vm._e(), _vm._v(" "), (scope.row.status == 2) ? _c('span', {
          staticClass: "amount-cur"
        }, [_vm._v(" 失败 ")]) : _vm._e()]
      }
    }], null, false, 2386803838)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "np_status",
      "label": "np状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.np_status == 0) ? _c('span', {
          staticClass: "amount-cur"
        }, [_vm._v(" 未处理 ")]) : _vm._e(), _vm._v(" "), (scope.row.np_status == 1) ? _c('span', {
          staticClass: "amount-cur"
        }, [_vm._v(" 成功 ")]) : _vm._e(), _vm._v(" "), (scope.row.np_status == 2) ? _c('span', {
          staticClass: "amount-cur"
        }, [_vm._v(" 失败 ")]) : _vm._e()]
      }
    }], null, false, 2012410658)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "return_status",
      "label": "退返积分状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.return_status == 0) ? _c('span', {
          staticClass: "amount-cur"
        }, [_vm._v(" 未退回 ")]) : _vm._e(), _vm._v(" "), (scope.row.return_status == 1) ? _c('span', {
          staticClass: "amount-cur"
        }, [_vm._v(" 已退回 ")]) : _vm._e()]
      }
    }], null, false, 3462057289)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "created",
      "label": "创建时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("datetime")(scope.row.created, 'yyyy-MM-dd hh:mm:ss')))])]
      }
    }], null, false, 2445216850)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "updated",
      "label": "更新时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("datetime")(scope.row.updated, 'yyyy-MM-dd hh:mm:ss')))])]
      }
    }], null, false, 2129078343)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticStyle: {
            "margin-left": "0"
          },
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.getRealTimePointxq(scope.row.params)
            }
          }
        }, [_vm._v("附加参数")]), _vm._v(" "), _c('el-button', {
          staticStyle: {
            "margin-left": "0"
          },
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.getRealTimePoint(scope.row.user_id, scope.row.card_id)
            }
          }
        }, [_vm._v("实时积分")]), _vm._v(" "), _c('el-button', {
          staticStyle: {
            "margin-left": "0"
          },
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.getOneYearsPoint(scope.row.user_id, scope.row.card_id)
            }
          }
        }, [_vm._v("1年积分明细")]), _vm._v(" "), _c('el-button', {
          staticStyle: {
            "margin-left": "0"
          },
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.returnPoint(scope.row.user_id, scope.row.card_id, scope.row.id, scope.row.return_status, scope.row.np_status, scope.row.status)
            }
          }
        }, [_vm._v("退返积分")])]
      }
    }], null, false, 98687755)
  })], 1), _vm._v(" "), (_vm.total_count > _vm.params.pageSize) ? _c('div', {
    staticClass: "content-padded content-center"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "current-page": _vm.params.page,
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "详情",
      "visible": _vm.realTimeDialogxq,
      "before-close": _vm.handleGetRealTimePointxq,
      "width": "57%"
    },
    on: {
      "update:visible": function($event) {
        _vm.realTimeDialogxq = $event
      }
    }
  }, [
    [_c('el-row', {
      attrs: {
        "gutter": 100
      }
    }, [_c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_vm._v("\n                        附加参数:" + _vm._s(_vm.realTimeData) + "\n                    ")])], 1)], _vm._v(" "), _c('div', {
      staticClass: "dialog-footer",
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [_c('el-button', {
      nativeOn: {
        "click": function($event) {
          return _vm.handleGetRealTimePointxq.apply(null, arguments)
        }
      }
    }, [_vm._v("确定")])], 1)
  ], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "实时积分",
      "visible": _vm.realTimeDialog,
      "before-close": _vm.handleGetRealTimePoint,
      "width": "57%"
    },
    on: {
      "update:visible": function($event) {
        _vm.realTimeDialog = $event
      }
    }
  }, [
    [_c('el-row', {
      attrs: {
        "gutter": 100
      }
    }, [_c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_vm._v("\n                        实时积分:" + _vm._s(_vm.realTimeData) + "\n                    ")])], 1)], _vm._v(" "), _c('div', {
      staticClass: "dialog-footer",
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [_c('el-button', {
      nativeOn: {
        "click": function($event) {
          return _vm.handleGetRealTimePoint.apply(null, arguments)
        }
      }
    }, [_vm._v("确定")])], 1)
  ], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "1年积分明细",
      "visible": _vm.realTimeDialog1years,
      "before-close": _vm.handleGetRealTimePoint1years,
      "width": "57%"
    },
    on: {
      "update:visible": function($event) {
        _vm.realTimeDialog1years = $event
      }
    }
  }, [
    [_c('el-row', {
      attrs: {
        "gutter": 100
      }
    }, [_c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_vm._v("\n                        剩余：" + _vm._s(_vm.realTimeData1years.integral) + "\n                    ")])], 1), _vm._v(" "), _c('el-table', {
      attrs: {
        "data": _vm.realTimeData1years.jfmx
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "credate",
        "label": "时间"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "thisintegral",
        "label": "积分"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "docid",
        "label": "docid"
      }
    })], 1)], _vm._v(" "), _c('div', {
      staticClass: "dialog-footer",
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [_c('el-button', {
      nativeOn: {
        "click": function($event) {
          return _vm.handleGetRealTimePoint1years.apply(null, arguments)
        }
      }
    }, [_vm._v("确定")])], 1)
  ], 2)], 1) : _vm._e(), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-322d958d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-322d958d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/duiba/orders/list.vue
// module id = 2597
// module chunks = 0